import React, { useState, useEffect } from 'react'

import { Button, Card, Table, Typography, Icon, Input } from 'antd'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'
// Main func
const ListBrands = function ({ match, history }) {
  const [formatedData, setFormatedData] = useState([])
  const [formValues, setFormValues] = useState({})
  const { count, page, pageSize } = formatedData
  // Created component
  useEffect(() => {
    listBrands(formValues)

    return () => {
      setFormValues({})
      setFormatedData({})
    }
  }, [])

  // Api requests
  async function listBrands(params) {
    try {
      const response = await request(api.listBrands(params))
      console.tron.log('response listBrands', response)
      const itens = response.items
      const formatedRows = []
      itens.map((item) => {
        return formatedRows.push({
          key: item.id,
          ...item,
          actions: formatActionsContent(item.id)
        })
      })
      setFormatedData({
        ...response,
        items: formatedRows,
        actions: 'teste'
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  function sortText(a, b, field) {
    if (a !== null && a[field] !== null && b !== null && b[field] !== null && field !== null) {
      if (a[field] < b[field]) return -1
      if (a[field] > b[field]) return 1
    }

    return 0
  }

  const columns = [
    {
      title: getMessage('description'),
      dataIndex: 'organizationName',
      sorter: (a, b) => sortText(a, b, 'organizationName')
    }
    // {
    //   title: getMessage("edit"),
    //   dataIndex: "actions"
    // }
  ]

  function onChange(pagination) {
    const { current } = pagination
    listBrands({
      page: current - 1,
      ...formValues
    })
  }

  const formatActionsContent = (id) => (
    <Button
      className="default-actionContent-button"
      type="link"
      onClick={() => {
        history.push(`/organization/${id}`)
      }}
    >
      <Icon type="edit" className="default-actionContent-icon" />
    </Button>
  )

  function renderHeader() {
    return (
      <div className="default-header-div">
        <Typography.Title className="default-header-title" level={3}>
          {getMessage('listBrands')}
        </Typography.Title>
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
        </div>
      </div>
    )
  }

  return (
    <>
      {renderHeader()}

      <Card className="ant-card gx-card ant-card-bordered">
        <Input.Search
          className="default-header-search"
          onSearch={(value) => listBrands({ search: value })}
          placeholder={getMessage('search')}
        />
        <Table
          key="id"
          columns={columns}
          dataSource={formatedData.items}
          onChange={onChange}
          pagination={{ pageSize, current: page + 1, total: count }}
        />
      </Card>
    </>
  )
}

export default ListBrands
